const { query } = require("../cloudaccounting");
const { setToken, getToken, isTokenExpired, removeToken } = require("../token");
const { getDebugMode } = require("../../helpers/methods");
const Cookies = require("js-cookie");

const COOKIE_NAME = "token";
const COOKIE_NAME_2 = "auth:token";

const login = async ({ email, password, token } = {}) => {
	const operationId = "auth.login";
	let _token = null;

	// Remove any login token
	Cookies.remove(COOKIE_NAME);
	Cookies.remove(COOKIE_NAME_2);
	removeToken();

	try {
		if (email && password) {
			if (getDebugMode()) {
				console.log("Login with email & password", { email, password });
			}

			try {
				const response = await query({
					operationId,
					data: {
						email,
						password
					}
				});

				if (getDebugMode()) {
					console.log("response", response);
				}

				if (response && response.access_token) {
					_token = response.access_token;
				}
			} catch (error) {
				console.error(error);

				if (getDebugMode()) {
					console.log("error login", error);
				}

				return false;
			}
		} else {
			if (getDebugMode()) {
				console.log("Login with token");
			}

			// Priority to the token in the parameters, if not provided get the token from the cookie
			_token = token ? token : getToken();

			if (_token) {
				if (isTokenExpired(_token)) {
					if (getDebugMode()) {
						console.log("isTokenExpired", true);
					}

					try {
						const { access_token } = await query({ operationId: "auth.refresh", token: _token }, true);

						_token = access_token;
					} catch (error) {
						removeToken();

						return false;
					}
				}
			} else {
				throw new Error("The login function require an email and password or a token.");
			}
		}

		if (getDebugMode()) {
			console.log("_token", _token);
		}

		setToken(_token);

		return true;
	} catch (error) {
		console.log("[authentication.js][login]", error);

		return Promise.reject(error);
	}
};

module.exports = login;
